import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const tabsProps = buildProps({
  /** 双向绑定 */
  modelValue: {
    type: [String, Number],
  },
  list: {
    type: definePropType<Record<string, any>[]>(Array),
    default: () => [],
  },
  labelKey: {
    type: String,
    default: "label",
  },
  valueKey: {
    type: String,
    default: "value",
  },
  type: {
    type: String,
    values: ["normal", "cap", "vertical", "card"],
    default: "normal",
  },
  size: {
    type: String,
    values: ["default", "mini"],
    default: "default",
  },
  /** next函数 */
  next: {
    type: definePropType<() => boolean | Promise<boolean>>(Function),
  },
  max: {
    type: Number,
  },
} as const);

export type TabsProps = ExtractPropTypes<typeof tabsProps>;
